<template>
  <div class="uk-width-1-1">
    <div class="uk-overlay-panel uk-flex uk-flex-center uk-flex-middle uk-overlay-panel-loading "  v-show="loading"> 
      <div class="loading">
        <div class="load"><span class="uk-icon-spinner uk-icon-spin"></span></div>
      </div>
    </div>  
  </div>
</template>
<script>
export default {
    name: 'loading',
    data() {
        return {
            
        }
    },
    created() {
        var that = this;
        this.bus.$on('loading', function(data) {
            that.loading = !!data;
        })
    },
    computed:{
      loading(){
        return this.$store.state.loading.loading;
      },
      

    }
}
</script>
<style scoped lang="scss">
.uk-overlay-panel{ position:fixed;  }
.uk-overlay-panel-loading{z-index: 99999;}
.uk-overlay-panel-waiting{background:#fff;z-index: 99990; }
.loading{ width:120px; height:120px; line-height:120px; color:#fff; background:rgba(0,0,0,.8); font-size:30px; border-radius:10px; text-align:center; position:relative;}
.loading p{ position:absolute; left:0;bottom:0;right:0; color:#fff; line-height:60px;}
</style>


// WEBPACK FOOTER //
// src/components/common/loading.vue